import React from 'react';

import { SettingsGroup } from '@eluve/blocks';
import {
  Field,
  FieldContent,
  FieldDescription,
  FieldLabel,
  Separator,
} from '@eluve/components';

import { InterfaceLanguageSettings } from './InterfaceLanguageSettings';
import { TenantLogoSettings } from './TenantLogoSettings';
import { TenantNameSettings } from './TenantNameSettings';

export const GeneralTenantSettings: React.FC = () => {
  return (
    <SettingsGroup title="General">
      <Field orientation="horizontal" className="px-6 py-7">
        <FieldLabel className="whitespace-nowrap">Logo</FieldLabel>
        <div className="flex w-full max-w-60 justify-end">
          <TenantLogoSettings />
        </div>
      </Field>
      <Separator className="my-0" />
      <Field orientation="horizontal" className="px-6 py-5">
        <FieldLabel className="whitespace-nowrap">Organization Name</FieldLabel>
        <div className="flex w-full max-w-60 justify-end">
          <TenantNameSettings />
        </div>
      </Field>
      <Separator className="my-0" />
      <Field orientation="horizontal" className="px-6 py-5">
        <FieldContent>
          <FieldLabel>Interface Language</FieldLabel>
          <FieldDescription className="text-balance">
            The default UI language for this organization's users, but those who
            explicitly chose one are not affected. Note: this only applies to
            the Chrome extension.
          </FieldDescription>
        </FieldContent>
        <div className="flex w-full max-w-60 justify-end">
          <InterfaceLanguageSettings />
        </div>
      </Field>
    </SettingsGroup>
  );
};
